import { useQuery } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { vtCamerasQuery } from "../queries";

interface UseCamerasOptions {
  siteId?: string | null;
}

export function useCameras(options?: UseCamerasOptions) {
  const apiConfig = useApiConfig();
  const siteId = options?.siteId;

  return useQuery({
    ...vtCamerasQuery(apiConfig, {}, { ...(siteId && { siteId }) }),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: "always",
  });
}
